<template>
  <div class="flex flex-col items-center">
    <h1 class="text-2xl">{{ t('langua.step_pin.title') }}</h1>
    <div>
      <pin-input ref="input" v-model="challengeId" :len="len" :disabled="inputDisabled" :animation="isAnimating" class="mt-8" />
      <div v-if="err" class="flex">
        <hint-box
          type="error"
          :title="t(err.error) || err.error"
          :content="t(err.errorMessage) || err.errorMessage"
          class="flex-grow w-0 mt-8"
        />
      </div>
      <div class="flex">
        <hint-box
          type="question"
          :title="t('langua.step_pin.hint_how_to_get_code.question')"
          :content="t('langua.step_pin.hint_how_to_get_code.answer')"
          class="flex-grow w-0 mt-8"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {onBeforeUnmount, onMounted, ref, watch} from '@vue/composition-api'

  import PinInput from '@/components/pin-input.vue'
  import HintBox from '@/components/hint-box.vue'
  import useMelonAuth from '@/composables/melon-auth'
  import useI18n from '@/composables/i18n'

  const LEN = 6

  let timer = null

  export default {
    name: 'PinView',

    components: {
      HintBox,
      PinInput,
    },

    setup (_, {emit}) {
      let {challengeId, verifyCode} = useMelonAuth()

      challengeId.value = ''

      const len = ref(LEN)
      const inputDisabled = ref(false)
      const isAnimating = ref(false)
      const err = ref(null)
      /** @type {{value: HTMLInputElement}} */
      const input = ref(null)

      async function submit () {
        inputDisabled.value = true
        isAnimating.value = true
        try {
          await verifyCode()
          emit('forward')
        } catch (e) {
          err.value = e
          challengeId.value = ''
          inputDisabled.value = false
          isAnimating.value = false
          await Vue.nextTick()
          input.value.focus()
        }
      }

      function onClickDocument () {
        input.value.focus()
      }

      watch(challengeId, value => {
        if (value.length === LEN) {
          timer = setTimeout(() => {
            timer = null
            submit()
          }, 300)
        } else {
          if (timer) clearTimeout(timer)
        }
      })

      onMounted(() => {
        input.value.focus()
        document.addEventListener('click', onClickDocument)
      })

      onBeforeUnmount(() => {
        document.removeEventListener('click', onClickDocument)
      })

      const {t} = useI18n()

      return {
        challengeId,
        len,
        inputDisabled,
        isAnimating,
        err,
        input,

        t,
      }
    },
  }
</script>
